import { Row, Typography } from '@tempmee/react';
import { OutlineCheckIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';

const ICON_SIZE = 24;

export const FreeToJoinBanner = () => (
  <Row
    align="center"
    gap={1}
    wrap="nowrap"
    style={{
      backgroundColor: colors.primary[50],
      borderRadius: 6,
      padding: '4px 12px 4px 8px',
      height: 30,
      width: 'fit-content',
    }}
    data-testid="free-to-join-banner"
  >
    <OutlineCheckIcon size={ICON_SIZE} color={colors.success[400]} />
    <Typography bold color={colors.primary[500]}>
      FREE to join- No credit card needed
    </Typography>
  </Row>
);
